import React from 'react';
import { Button } from 'antd-mobile';
import style from './index.module.css';

const Download: React.FC = () => {
  const handleDownload = () => {
    // 创建下载链接
    const link = document.createElement('a');
    link.href = '/haochuzi_release_v1.0_202509121712.apk';
    link.download = 'haochuzi_release_v1.0_202509121712.apk';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className={style.container}>
      <div className={style.content}>
        {/* 应用Logo */}
        <div className={style.logoSection}>
          <img 
            src="/WechatIMG336.jpg" 
            alt="郝厨子" 
            className={style.logo}
          />
          <h1 className={style.appName}>郝厨子</h1>
          <p className={style.appDesc}>专业的餐饮管理应用</p>
        </div>

        {/* 版本信息 */}
        <div className={style.versionInfo}>
          <div className={style.versionItem}>
            <span className={style.versionLabel}>版本：</span>
            <span className={style.versionValue}>v1.0</span>
          </div>
          <div className={style.versionItem}>
            <span className={style.versionLabel}>大小：</span>
            <span className={style.versionValue}>约 15MB</span>
          </div>
          <div className={style.versionItem}>
            <span className={style.versionLabel}>系统：</span>
            <span className={style.versionValue}>Android 5.0+</span>
          </div>
          <div className={style.versionItem}>
            <span className={style.versionLabel}>更新：</span>
            <span className={style.versionValue}>2024-09-12</span>
          </div>
        </div>

        {/* 下载按钮 */}
        <div className={style.downloadSection}>
          <Button
            color="primary"
            size="large"
            className={style.downloadButton}
            onClick={handleDownload}
          >
            立即下载 Android 版本
          </Button>
          
          <div className={style.downloadNote}>
            <p>• 支持 Android 5.0 及以上系统</p>
            <p>• 如下载失败，请检查网络连接</p>
            <p>• 安装前请允许未知来源应用</p>
          </div>
        </div>

        {/* 功能介绍 */}
        <div className={style.features}>
          <h3>主要功能</h3>
          <ul>
            <li>餐饮数据统计分析</li>
            <li>销售记录管理</li>
            <li>菜品管理系统</li>
            <li>厨师工作管理</li>
            <li>历史数据查询</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Download;